// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chats',
  new_chat: 'Neuer Chat',
  note: {
    team: 'Alle Chats zu {{restaurant}}: deine, die deines Teams und die des Restaurants.',
    own: 'Deine Chats zu {{restaurant}}.',
  },
  log: 'Alle Anfragen im Amigo-Protokoll',
  days: {
    today: 'Heute',
    yesterday: 'Gestern',
    earlier: 'Früher',
  },
  who: {
    you: 'Du',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Inhaber',
      staff: 'Mitarbeiter',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Erledigt',
    answered: 'Beantwortet',
    waiting: 'Wartet auf Freigabe',
    partial: '{{applied}} von {{total}} übernommen',
    rejected: 'Abgelehnt',
    not_yet: 'Noch nicht möglich',
    failed: 'Fehlgeschlagen',
  },
  none: {
    title: 'Noch keine Chats zu {{restaurant}}',
    text: 'Chats, die du hier startest, bleiben hier, damit du zu ihnen zurückkommen kannst.',
  },
  loading: 'Chats werden geladen…',
  loading_more: 'Weitere Chats werden geladen…',
  load_failed: 'Die Chats konnten nicht geladen werden.',
  retry: 'Erneut versuchen',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Neue Antwort:',
  new_answers_other: 'Neue Antworten:',
};
